import { render, staticRenderFns } from "./legalDeclarationCN.vue?vue&type=template&id=51ecb288&scoped=true"
import script from "./legalDeclarationCN.vue?vue&type=script&lang=js"
export * from "./legalDeclarationCN.vue?vue&type=script&lang=js"
import style0 from "./legalDeclarationCN.vue?vue&type=style&index=0&id=51ecb288&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecb288",
  null
  
)

export default component.exports